module.exports = __webpack_public_path__ + "static/media/MenuApiDescription.c636282b.svg";